import api from './api';

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const settingsAPIInstance = axios.create({
//   baseURL: `${API_BASE_URL}/settings`,
//   withCredentials: true, // Important for session cookies
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Add request interceptor to include auth token if available
// settingsAPIInstance.interceptors.request.use(
//   (config) => {
//     // Add any auth headers here if needed
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Add response interceptor for error handling
// settingsAPIInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       // Authentication required - let the component handle this
//       console.log('Authentication required for settings API');
//     }
//     return Promise.reject(error);
//   }
// );

const settingsAPIInstance = {
  get: (url, config) => api.get(`/settings${url}`, config),
  post: (url, data, config) => api.post(`/settings${url}`, data, config),
  put: (url, data, config) => api.put(`/settings${url}`, data, config),
  delete: (url, config) => api.delete(`/settings${url}`, config),
  interceptors: api.interceptors
};

// Account Settings API calls
export const settingsAPI = {
  // Get user account settings
  getUserAccountSettings: async () => {
    try {
      const response = await settingsAPIInstance.get('/account');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch account settings');
    }
  },

  // Update session settings
  updateSessionSettings: async (lifetime) => {
    try {
      const response = await settingsAPIInstance.put('/session', { lifetime });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update session settings');
    }
  },

  // Toggle two-way authentication
  toggleTwoWayAuth: async (status) => {
    try {
      const response = await settingsAPIInstance.put(`/two-way-auth/${status}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to toggle two-way authentication');
    }
  },

  // Clear cache
  clearCache: async () => {
    try {
      const response = await settingsAPIInstance.post('/clear-cache');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to clear cache');
    }
  },

  // Follow-up Templates API calls
  getFollowUpTemplates: async () => {
    try {
      const response = await settingsAPIInstance.get('/follow-up-templates');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch follow-up templates');
    }
  },

  // Create or update follow-up template
  storeFollowUpTemplate: async (templateData) => {
    try {
      const response = await settingsAPIInstance.post('/follow-up-templates', templateData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to save follow-up template');
    }
  },

  // Get template by ID
  getTemplateById: async (templateId) => {
    try {
      const response = await settingsAPIInstance.get(`/follow-up-templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch template');
    }
  },

  // Delete template
  deleteTemplate: async (templateId) => {
    try {
      const response = await settingsAPIInstance.delete(`/follow-up-templates/${templateId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete template');
    }
  },

  // Get template content
  getTemplateContent: async (templateId) => {
    try {
      const response = await settingsAPIInstance.get(`/follow-up-templates/${templateId}/content`);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch template content');
    }
  },

  // Calendar Permission API calls
  getCalendarPermissions: async () => {
    try {
      const response = await settingsAPIInstance.get('/calendar-permissions');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch calendar permissions');
    }
  },

  createCalendarPermission: async (permissionData) => {
    try {
      const response = await settingsAPIInstance.post('/calendar-permissions', permissionData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to create calendar permission');
    }
  },

  updateCalendarPermission: async (permissionId, permissionData) => {
    try {
      const response = await settingsAPIInstance.put(`/calendar-permissions/${permissionId}`, permissionData);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update calendar permission');
    }
  },

  deleteCalendarPermission: async (groupKey) => {
    try {
      const response = await settingsAPIInstance.post('/calendar-permissions/delete', { groupKey });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete calendar permission');
    }
  },

  getCaregiversForPermission: async () => {
    try {
      const response = await settingsAPIInstance.get('/caregivers-for-permission');
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch caregivers');
    }
  }
};

export default settingsAPI;
